// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"56":"2f966e97","188":"c39ec77d","217":"d159e855","219":"25daba08","315":"cb6524df","353":"ed67cd42","382":"e1c2c508","498":"b5bb9051","501":"3f7fa8bb","510":"ca877dee","528":"26e3e872","568":"52499a06","735":"1ba68ff9","784":"d74a206c","787":"cc1dd508","892":"371a8877"}[chunkId] + ".js";
};